import { TreeItem, treeItemClasses } from '@mui/x-tree-view';
import { alpha, styled, typographyClasses } from "@mui/material";

export const StyledTreeItem = styled(TreeItem)(({ theme }) => ({
    [`& .${treeItemClasses.groupTransition}`]: {
      marginLeft: 15,
      paddingLeft: 18,
      borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },

    [`& .product > .${treeItemClasses.content}.${treeItemClasses.expanded} .${treeItemClasses.label}`]: {
      background: theme.palette.action.selected,
      color: theme.palette.text.primary,
    },

    [`& .product > .${treeItemClasses.content}.${treeItemClasses.expanded} .${treeItemClasses.label} .${typographyClasses.body2}`]: {
      background: theme.palette.action.selected,
      color: theme.palette.text.primary,
      fontWeight: 'bold'
    },

    [`& > .${treeItemClasses.content}.${treeItemClasses.selected} .${treeItemClasses.label}`]: {
      background: theme.palette.action.selected,
      color: theme.palette.text.primary,
    },

    [`& > .${treeItemClasses.content}.${treeItemClasses.selected} .${treeItemClasses.label} .${typographyClasses.body2}`]: {
      color: theme.palette.text.primary,
      fontWeight: 'bold',
    },

    [`& .${treeItemClasses.root}`]: {
      marginTop: 5,
    }
  }));